import { mapState } from 'vuex'

import { isInStoreRecord } from '@/utils/utils'
import AgentAndStoreTab from '@/pages/agent/components/AgentAndStoreTab/AgentAndStoreTab.vue'
import { getStoreInfo } from '@/utils/http/modules/agent/agent.request'

export const agentStoreMixin = {
  components: {
    AgentAndStoreTab,
  },
  data() {
    return {
      agentStoreTab: 'mine',
      agentStoreId: void 0,
      agentStoreName: '',
      hasStoreTabAuth: false,
    }
  },

  computed: {
    ...mapState(['agentAuthList']),
    isAdmin() {
      return ['CREATOR', 'ADMIN'].some(
        v =>
          window.userInfo &&
          window.userInfo.roles &&
          window.userInfo.roles.includes(v)
      )
    },
    // 是否在门店报表中
    isInStoreRecord() {
      return isInStoreRecord()
    },
    // 门店报表权限列表
    agentAuthPermCodeList() {
      if (Array.isArray(this.agentAuthList)) {
        const storeReport = this.agentAuthList.find(
          item => item.permCode === 'store_report'
        )
        if (!storeReport) {
          return []
        }
        return this.agentAuthList
          .filter(item => parseInt(item.parentId) === storeReport.id)
          .map(item => item.permCode)
      }
      return []
    },
  },

  activated() {
    this.onAgentStoreLoad()
  },

  methods: {
    hasStoreAuth(permCode) {
      const agentHasAuth = () => {
        if (this.agentAuthPermCodeList.length <= 0) {
          return false
        }
        const hasAuth = this.agentAuthPermCodeList.includes(permCode)
        return hasAuth
      }
      return agentHasAuth()
    },

    /**
     * 获取门店信息
     * @param {Number} storeId 门店id
     */
    async getStoreInfo(storeId) {
      if (!storeId) return Promise.reject('storeId is required')
      try {
        const res = await getStoreInfo({ zbId: window.zbvd.zbid, storeId })
        if (res.code == 0 && res.isok) {
          return res.dataObj
        }
      } catch (error) {
        return Promise.reject(error)
      }
    },

    async onAgentStoreLoad(defaultStoreId) {
      if (this.noOnAgentStoreLoad) return
      const { storeTab, storeId } = this.$route.query
      if (storeTab > 0) {
        this.agentStoreTab = 'store'
        try {
          const storeInfo = await this.getStoreInfo(storeId)
          this.$nextTick(() => {
            if (this.$refs.agentAndStoreTabRef) {
              this.$refs.agentAndStoreTabRef.currentStore = {
                storeId,
                storeName: storeInfo?.title || '',
              }
            }
          })
        } catch (error) {
          console.error(error)
        }
      } else {
        this.agentStoreTab = 'mine'
      }
    },
  },
}
